<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.q" placeholder="请输入订单号查询" style="width:250px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList">查询</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px;">
          <el-tag type="info">只显示两年内的信息</el-tag>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="listdata" highlight-current-row v-loading="loading" @selection-change="selsChange"
      style="width: 100%;">
      <el-table-column type="index" width="60">
      </el-table-column>
      <!-- <el-table-column label="ID" prop="id" sortable="custom" align="center" width="100">
        <template slot-scope="{row}">
          <a :href="'http://m.jazpan.com/pays/' + row.Vwid" target="_blank">{{ row.Id }}</a>
        </template>
</el-table-column>
<el-table-column prop="Typ" label="类型" width="80" align="center" /> -->
      <el-table-column label="文件">
        <template slot-scope="{row}">
          <a target="_blank" :href="'//jazpan.com/view/'+(row.infoMap.fid||row.Fid)">{{ row.infoMap.fname }}</a>
        </template>
      </el-table-column>
      <!-- <el-table-column label="上传人" width="200">
        <template slot-scope="{row}">
          <el-button type="text" @click="$eventBus.$emit('showUserDetail', row.Fuid)">{{ row.infoMap.funick }}
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="金额" align="center" width="120">
        <template slot-scope="{row}">
          <span class="amountxs">{{ row.infoMap.flamts }}</span>
          <!-- + <span class="amountxs">{{ row.infoMap.amts }}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Mxid" label="订单ID" width="120" align="center" /> -->
      <el-table-column label="订单ID" width="120" align="center">
        <template slot-scope="{row}">
          <el-popover placement="top-start" title="订单号" width="200" trigger="hover"
            :content="'[' + row.Mxid + ']: ' + row.Mchid">
            <span slot="reference">{{ row.Mxid }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="下载人" width="135" align="center">
        <template slot-scope="{row}">
          <span>{{ row.Ips }}</span>
          <p v-if="row.Uid != ''"><a target="_blank" :href="'//jazpan.com/user/' + row.Uid">
              {{ row.infoMap.nick }}
            </a></p>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80px" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.Stat == -1" type="danger">禁止下载</el-tag>
          <el-tag v-else-if="row.Stat == 0" type="info">未下载</el-tag>
          <el-tag v-else-if="row.Stat == 1" type="warning">下载中</el-tag>
          <el-tag v-else-if="row.Stat == 2" type="success">已下载</el-tag>
          <el-tag v-else>{{ row.Stat }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="大小" width="120px" align="center">
        <template slot-scope="{row}">
          <span>
            {{ getFlSize(row.Sizeln) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="下载时间" width="180px" align="center">
        <template slot-scope="{row}">
          <span>{{ row.Timestr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template scope="{row}">
          <el-button-group>
            <!-- <el-button v-if="row.Stat == 0" size="mini" type="warning" @click="revokeBackFun(row)">撤回</el-button> -->
            <!-- <el-button size="small" type="danger" @click="handleDel(row)">删除</el-button> -->
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination layout="prev, pager, next" :current-page.sync="filters.page" :total="total" :page-size="limit"
        @current-change="getList" style="float:right;">
      </el-pagination>
      <txTaxTips ref="txTaxTips" />
    </el-col>
  </section>
</template>

<script>
import util from '@/common/js/util'
import txTaxTips from '@/views/ruis/user/txTaxTips';
export default {
  components: { txTaxTips },
  data() {
    return {
      filters: {
        page: 1,
        s: '',
        q: ''
      },
      loading: false,
      total: 0,
      limit: 0,
      listdata: [],
      sels: [],//列表选中列
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getFlSize: util.getFlSize,
    //获取列表
    getList() {
      this.loading = true;
      //NProgress.start();
      this.$post('/user/orders', this.filters).then((res) => {
        console.log(res);
        this.loading = false;
        this.listdata = res.data.Data;
        this.total = res.data.Total;
        this.limit = res.data.Size;
        this.filters.page = res.data.Page;
        //NProgress.done();
      }).catch(err => {
        this.$message({
          message: err.response.data || '服务器错误',
          type: 'error'
        });
      });
    }, selsChange(sels) {
      this.sels = sels;
    }, handleAdd() {

    }, handleEdit() {

    }
  }
}

</script>

<style scoped>
.wxmpTit {
  line-height: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.wxmpTit img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// OrderList.vue?21a16749